<template>
  <thead>
    <tr class="cusmtom-thead-color">
      <td rowspan="3" class="text-center p-3 custom-header-label">
        {{ $t('common_words.allotment') }}
      </td>
      <td rowspan="3" class="text-center p-3 custom-header-label">
        {{ $t('production.has') }}
      </td>
      <td rowspan="3" class="text-center p-3 custom-header-label">
        {{ $t('production.defect') }}
      </td>
    </tr>
    <tr class="cusmtom-thead-color">
      <td
        v-for="(edge, i) in reduceColumnByEdge()"
        :key="i"
        class="text-center p-3"
        :rowspan="[100, 200].includes(edge) ? 3 : 1"
        :colspan="getColSpan(edge)"
      >
        {{
          [100, 200].includes(edge)
            ? edge === 100
              ? $t('production.young')
              : $t('production.banana_flowers')
            : `${edge} ${$t('common_words.week_short')}`
        }}
      </td>
      <td rowspan="3" class="text-center p-3 custom-header-label">
        {{ $t('common_words.total_mayus') }}
      </td>
    </tr>
    <tr>
      <template v-for="(row, i) in columns">
        <td
          v-if="![100, 200].includes(row.edge)"
          :key="i"
          class="text-center p-3"
          v-bind:style="getStyleCellRibbon(row)"
        >
          {{ translateDataBaseText(row.color_name, row.other_values) }}
        </td>
      </template>
    </tr>
  </thead>
</template>
<script>
import MixinTranslate from 'src/util/mixinTranslate';

export default {
  name: 'thead-ribbons',
  props: {
    columns: {
      type: Array,
      default: [],
    },
  },
  mixins: [MixinTranslate],
  methods: {
    getStyleCellRibbon(row) {
      return (
        'background-color:' +
        row.color_code +
        ';color:' +
        row.color_text +
        '; font-weight: bold;'
      );
    },

    getColSpan(edge) {
      const response = this.columns.filter((column) => column.edge === edge);
      return response ? response.length : 1;
    },

    reduceColumnByEdge() {
      const reduce = [];
      this.columns.forEach((column) => {
        if (!reduce.includes(column.edge)) reduce.push(column.edge);
      });

      return reduce.sort((a, b) => a - b);
    },
  },
};
</script>
